import { IntegrationCardButton } from './IntegrationCardButton'
import { IntegrationCardContent } from './IntegrationCardContent'
import { IntegrationCardDescription } from './IntegrationCardDescription'
import { IntegrationCardFooter } from './IntegrationCardFooter'
import { IntegrationCardHeader } from './IntegrationCardHeader'
import { IntegrationCardImage } from './IntegrationCardImage'
import { IntegrationCardMail } from './IntegrationCardMail'
import { IntegrationCardRoot } from './IntegrationCardRoot'
import { IntegrationCardStatus } from './IntegrationCardStatus'
import { IntegrationCardTitle } from './IntegrationTitle'

export const IntegrationCard = {
  Button: IntegrationCardButton,
  Content: IntegrationCardContent,
  Description: IntegrationCardDescription,
  Footer: IntegrationCardFooter,
  Header: IntegrationCardHeader,
  Image: IntegrationCardImage,
  Mail: IntegrationCardMail,
  Root: IntegrationCardRoot,
  Status: IntegrationCardStatus,
  Title: IntegrationCardTitle,
}
